import "@/App.css";
import { NoiseOverlay } from "@/components/NoiseOverlay";
import { ThemeToggle } from "@/components/ThemeToggle";
import { HeroSection } from "@/components/HeroSection";
import { MarqueeBand, PositioningSection } from "@/components/PositioningSection";
import { KravMagaSection } from "@/components/KravMagaSection";
import { TrainingOptionsSection } from "@/components/TrainingOptionsSection";
import { WhyTrainSection } from "@/components/WhyTrainSection";
import { InstagramSection } from "@/components/InstagramSection";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";

function App() {
  return (
    <div className="min-h-screen bg-page text-ink relative">
      <NoiseOverlay />
      <ThemeToggle />
      <main>
        <HeroSection />
        <MarqueeBand />
        <PositioningSection />
        <KravMagaSection />
        <TrainingOptionsSection />
        <WhyTrainSection />
        <InstagramSection />
        <ContactSection />
        <Footer />
      </main>
    </div>
  );
}

export default App;
